import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import "../../Styles/yellocalfcss/SelectStudent.css";
import ApiConfig from '../../api/ApiConfig';
import { simplePostCall } from '../../api/ApiServices';

const ViewInvoiceimp = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

 const handleImport = async () => {
    if (!selectedFile) {
      alert("Please select a file first");
      return;
    }

    setIsImporting(true);
    
    // 1. Prepare FormData
    const formData = new FormData();
    formData.append("upload_file", selectedFile);
    // Note: If your API expects customer_id and api_key in the body, append them here:
    formData.append("customer_id", localStorage.getItem("customer_id"));
    formData.append("api_key", localStorage.getItem("api_key"));

    try {
      // 2. Execute fetch with Headers
      const response = await fetch(ApiConfig.importarrears, {
        method: 'POST',
        headers: {
          // Add your custom headers here
          "customer_id": localStorage.getItem("customer_id"),
          "api_key": localStorage.getItem("api_key"),
          // "Authorization": `Bearer ${localStorage.getItem("token")}` // Example if needed
        },
        body: formData, // Browser handles Content-Type automatically for FormData
      });

      const result = await response.json();
      
      if (result.result || result.status === "success") {
        alert("Import Successful");
      } else {
        alert(result.message || "Import failed");
      }
    } catch (error) {
      console.error("Import failed", error);
      alert("An error occurred during import.");
    } finally {
      setIsImporting(false);
    }
  };

  const [exportLoading, setExportLoading] = useState(false)
  const downloadInvoiceTemplate = async () => {
  setExportLoading(true);
  try {
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")) || 1609,
      api_key:
        localStorage.getItem("api_key") || "3b1dee376ed4c6c61db0a25240a13c09",
      user_id: Number(localStorage.getItem("user_id")) || 56950,
      language: "en",
    };

    const response = await simplePostCall(
      ApiConfig.invoiceTemplateExport, // map this to /api/accountant/invoice-template-export
      JSON.stringify(requestBody)
    );

    if (response?.result && response?.import) {
      // Trigger file download
      const link = document.createElement("a");
      link.href = response.import;
      link.download = "invoice_template.xls";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Template download failed:", response?.message);
    }
  } catch (error) {
    console.error("Error downloading invoice template:", error);
  } finally {
    setExportLoading(false);
  }
};


  return (
    <div className="SelectStudent-container my-4">
      <div className="SelectStudent-invoice-header">
        <h4>Import Invoice</h4>
      </div>

      <div className="SelectStudent-invoice-form mt-3 p-4">
        <h6>Upload File</h6>
        <div className="d-flex align-items-center gap-3 mt-2">
          <input 
            type="file" 
            className="form-control w-auto" 
            onChange={handleFileChange}
            accept=".csv, .xlsx"
          />
        </div>
        
        <div className="mt-4 d-flex gap-2">
          <button  style={{backgroundColor: "var(--color-primary)"}} className="btn btn-info text-white px-4" onClick={handleImport} disabled={isImporting}>
            {isImporting ? <Spinner size="sm" /> : 'Import'}
          </button>
          <button  style={{backgroundColor: "var(--color-primary)"}} disabled={exportLoading} className="btn text-white" onClick={downloadInvoiceTemplate}>
            {exportLoading ? <Spinner size="sm" /> : "Download Import Format"} 
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewInvoiceimp;